export default __webpack_public_path__ + "img/17a678138f224b1e6565620ec02ff548.png";